(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunstone-section-179"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sunstone-section-179')) {
 customElements.define('sunstone-section-179', class extends HTMLElement {
  connectedCallback() {
   if(this.ready) return;
   const q=k=>this.querySelector('[data-key="'+k+'"]');
   const price=q('ind-price'),rate=q('ind-rate');
   if(!price||!rate)return;
   this.ready=true;
   const fmt=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(n);
   const calc=()=>{
    const p=Number(price.value),r=Number(rate.value);
    const valid=price.value.trim()!==''&&Number.isFinite(p)&&p>=0&&p<=2560000;
    price.setAttribute('aria-invalid',String(!valid));
    const values={'o-savings':valid?fmt(p*r/100):'—','o-price':valid?fmt(p):'—','o-rateLabel':r+'%','o-after':valid?fmt(p*(1-r/100)):'—'};
    Object.entries(values).forEach(([k,v])=>{if(q(k))q(k).textContent=v});
    this.querySelectorAll('.preset').forEach(b=>b.setAttribute('aria-pressed',String(valid&&Number(b.dataset.price)===p)));
   };
   this.querySelectorAll('.preset').forEach(b=>b.addEventListener('click',()=>{price.value=b.dataset.price;calc()}));
   price.addEventListener('input',calc);rate.addEventListener('change',calc);calc();
  }
 });
}


  } catch(e) { console.error(e); }
})();
})();
